import React, { useState } from 'react';
import earth1 from '../image/earth.png';
import earth from '../image/eath.jfif';
import todo from '../image/todo.jpg';
import todo1 from '../image/todo1.png';
import '../App.css';
import '../css/earth.css';

export const AddTodo = (props) => {
    const [title, setTilte] = useState("");
    const [desc, setDesc] = useState("");
    const submit = (e) => {
        e.preventDefault();
        if (!title || !desc) {
            alert('Title or Desciption is not define')
        }
        else {
            props.addTodo(title, desc);
            setTilte('');
            setDesc('');
        }
    }
    return (
        <div onSubmit={submit}>
            <header className="App-header">
                <>
                    <h1>My Todo App</h1>
                </>
                <img src={earth} className="App-logo img " alt="logo" />
                <p>
                    Stay focused, organized, and calm with <code>My Todo List.</code> The world's leading to-do list and task management app.
                </p>
                <p className='h6'>
                    Inspirational designs, illustrations, and graphic elements from the world’s best designers.<br/>
                    Want more inspiration? Browse our search results...
                </p>
            </header>
            <div className="container-fluid my-5 ">
                <div className="container-fluid bg1">
                    <div className="container main">
                        <div className="row">
                            <div className="col col-xs col-sm col-md">
                                <h2 className='text-start h2'>Add your tasks.<br />Organize your life.<br />Achieve more every day.</h2>
                                <p className='text-start h5'>Add tasks like "Check work email every day at 10:00 am". to<br /> complete your to-do list in seconds using the powerful natural <br />language recognition and recurring data of My To-Do List.</p>
                            </div>
                            <div className="col col-xs col-sm col-md">
                                <img src={todo} alt="" className='todoimg img-fluid border border-danger border-4' />
                            </div>
                        </div>
                        <div className="row my-5 main1">
                            <div className="col col-xs col-sm col-md">
                                <img src={todo1} alt="" className='todoimg img-fluid border border-danger border-4' />
                            </div>
                            <div className="col col-xs col-sm col-md">
                                <h2 className='text-start h2'>Reach that intellectual readability <br />you’ve been longing for.</h2>
                                <p className='text-start h5'>Your to-do lists are robotically looked after into Today,<br /> Upcoming and custom Filter perspectives that will help <br />you attention in your maximum vital things.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <h3 className='fw-bold bg-dark text-light text-center my-4 border border-danger border-3'>Add Todo</h3>
                        <div className="col bg-dark text-light px-5 py-3 border border-warning border-3">
                            <form className='text-start'>
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label fw-bold">Todo Title</label>
                                    <input type="text" value={title} onChange={(e) => { setTilte(e.target.value) }} className="form-control" id="title" aria-describedby="emailHelp" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="desc" className="form-label fw-bold">Todo Description</label>
                                    <input type="text" value={desc} onChange={(e) => { setDesc(e.target.value) }} className="form-control" id="desc" />
                                </div>
                                <button type="submit" className="btn btn-outline-primary fw-bold">Submit</button>
                            </form>
                        </div>
                        <div className="col bg-dark border border-warning border-3">
                            <img src={earth1} alt="" className='earth-logo img-fluid' />
                            <h5 className='lead fw-bold text-danger'>The Earth</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
